<script>

import { VueEditor } from 'vue2-quill-editor'
import InputTag from 'vue-input-tag'
import CustomerApi from "@/services/customers-api";
import Swal from "sweetalert2";


export default {

    components:{VueEditor, InputTag},

    data(){
        return{
            showAddNoteModal:false,
            custmerNote:{id:null, note: null},
            noteTypes:null,
            notesList:[],
            selectedNoteType:null,
            isGetNotesListStarting:false,
            pagemodel: {currentPage : 1, perPage :50, totalRows: 0, maxPagesCount: 0},
            tagKey:0,

            customToolbar: [
                [{ 'header': [1, 2, 3, 4, 5, 6, false] }], 
                ['bold', 'italic', 'underline', 'strike'],
                [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                [{ 'color': [] }, { 'background': [] }],
                [{ 'align': [] }],
            ],

        }
    },

    props: {
        customerId:{
            type:Number,
            default: null 
        },

      },

      mounted(){
        this.getNoteTypes()
        this.getNoteByCustomer()

      },

      methods:{

        cancelNote(){
            this.custmerNote = {id:null, note: null , tagsList:[] , type:null}
            this.tagKey++
            this.selectedNoteType = null
        },

        loadMoreNotes(){
            this.pagemodel.currentPage++;
            this.getNoteByCustomer()
        },


        deleteNote(customerNote){
            Swal.fire({
              title: "Supprimer cette note définitivement ?",
              icon: "warning",
              showCancelButton: true,
              confirmButtonColor: "#34c38f",
              cancelButtonColor: "#d11010",
              confirmButtonText: "Oui, Supprimer",
              cancelButtonText: "Annuler",
            }).then((result) => {
              if (result.value) {
                this.isGetNotesListStarting = true
                this.pagemodel.currentPage = 1
                CustomerApi.deleteNote(this.pagemodel.currentPage, this.pagemodel.perPage, customerNote.id).then(result=>{
                    if(result){
                        this.notesList=result.list;
                        this.pagemodel.totalRows = result.total;
                        this.pagemodel.currentPage = result.page;
                        this.pagemodel.perPage = result.pageSize;
                        this.pagemodel.pageSize = result.pageSize;
                        this.pagemodel.maxPagesCount = result.maxPagesCount ;
                        this.isGetNotesListStarting = false

                    }
                })
              }
            });
        },

        updateNote(customerNote){
            this.custmerNote = customerNote
            this.selectedNoteType = this.noteTypes.find(type => type.value === 1);
            this.tagKey++

            this.goTopPage()

        },

        
        typeToLabel(type) {
            switch(type) {
            case 0: return 'Réunion';
            case 1: return 'Appel téléphonique';
            case 2: return 'Autre';
            default: return 'Autre';
            }
        },

        getAvatarName(name) {
            if (typeof name !== 'string' || name.trim() === '') return '';
            const initials = name.split(' ')
                .map(word => word.charAt(0).toUpperCase())
                .join('');
            return initials;
        },

        getNoteByCustomer(){
            this.isGetNotesListStarting = true
        CustomerApi.getNoteByCustomer(this.pagemodel.currentPage, this.pagemodel.perPage, this.customerId).then(result=>{
            if(result){
                this.notesList.push(...result.list)
                this.pagemodel.totalRows = result.total;
                this.pagemodel.currentPage = result.page;
                this.pagemodel.perPage = result.pageSize;
                this.pagemodel.pageSize = result.pageSize;   
                this.pagemodel.maxPagesCount = result.maxPagesCount ;       
                this.isGetNotesListStarting = false

              }
        })
    },



        addNote(){
            this.isGetNotesListStarting = true
            const customerNote={
                id:this.custmerNote.id == null ? null : this.custmerNote.id,
                customerId:this.customerId,
                note:this.custmerNote.note,
                type:this.selectedNoteType == null ? null : this.selectedNoteType.value,
                tagsList:this.custmerNote.tagsList,
            }
            this.pagemodel.currentPage = 1
            CustomerApi.addNote(this.pagemodel.currentPage, this.pagemodel.perPage,customerNote ).then(result=>{
                this.notesList=result.list;
                this.pagemodel.totalRows = result.total;
                this.pagemodel.currentPage = result.page;
                this.pagemodel.perPage = result.pageSize;
                this.pagemodel.pageSize = result.pageSize;
                this.pagemodel.maxPagesCount = result.maxPagesCount ;
                this.isGetNotesListStarting = false
                this.cancelNote()

            })
        },

        getNoteTypes(){
            CustomerApi.getNoteTypes().then(result=>{
                if(result){
                    this.noteTypes = result

                }
             }
            )

        },

        onEditorChange(event) {
            this.custmerNote.note =event.html ;
        },

        openAddNoteModal(){
            this.showAddNoteModal = true

        },
        goTopPage() {
            window.scrollTo({top: 0,left: 0,behavior: 'smooth'});
            },

      }
      

}
</script>

<template>
    <div>
        
         <!-- Add/Edit note on the right -->
         <div class="card mb-4 p-4" >
            <div class="note-container">

                <div class="row">

                    <div class="col-md-8 col-12">
                        <div class="row d-flex align-items-stretch">
                <div class="mr-4 flex-grow-1 d-flex align-items-stretch"  >
                    <b-form-group v-if="noteTypes" :label="$t('customer.note.input.type')" label-for="" class="text-dark w-100">
                        <v-select class="style-vselect-big" style="font-size:1.2em; background-color: white;" :options="noteTypes" :placeholder="$t('customer.note.placeholder.type')" label="type" v-model="selectedNoteType">
                            <span slot="no-options">{{$t('lists.emptyLists.label')}}</span>
                        </v-select>
                    </b-form-group>
                </div>
                <div class="flex-grow-1 d-flex align-items-stretch"  >
                    <b-form-group :label="$t('customer.note.placeholder.tags')" class="text-dark w-100">
                        <input-tag :key="tagKey" class="form-control font-size-16" :placeholder="$t('customer.note.input.tags')" v-model="custmerNote.tagsList"/>
                    </b-form-group>
                </div>
            </div>
                    </div>

                    <div class="col-md-4 col-12">
                        <div>
                            <b-form-group class="m-0 p-0" label-for="">
                                <b-button variant="primary" @click="addNote()" class="float-sm-right text-uppercase font-weight-bold">  
                                    Ajouter une note
                                </b-button>     
                                <b-button variant="outline-dark mr-2 ml-md-0 ml-2" v-if="custmerNote && custmerNote.id" @click="cancelNote()" class="float-sm-right text-uppercase font-weight-bold">  
                                    {{$t("buttons.cancel")}}
                                </b-button>              
                            </b-form-group>
                        </div>
                    </div> 
                </div>

                









                <b-form-group :label="$t('customer.note.input.note')" class="text-dark mt-4" label-for="">
                    <vue-editor v-model="custmerNote.note" :editorToolbar="customToolbar" style="background-color: white;"></vue-editor>
                </b-form-group>

               

               
            </div>
        </div>
        

        <!-- Notes list on the left -->
        <div v-if="notesList && notesList.length" class="mt-0 mb-5">
            <div class="note-container">
            <div v-for="customerNote in notesList" :key="customerNote.id">
                <div class="card note-card  mt-5">
                    <div class="card-body">

                        <div variant="outline-primary"  class="float-sm-right mt-2 mt-lg-0 mt-xl-0 mt-md-0 font-size-18">
                            <b-badge href="#" variant="light" class="text-primary text-uppercase font-weight-bold">{{ typeToLabel(customerNote.type) }}</b-badge>
                        </div>


                        <div class="d-flex align-items-center mb-2">
                            <div class="avatar mr-2">
                                {{ getAvatarName(customerNote.arthurName) }}
                            </div>
                            <div class="ml-3">
                                <div class="text-primary font-size-16 font-weight-bold">{{ customerNote.arthurName }}</div>
                                <div class="mt-2"><i class="fas fa-clock mr-2 font-size-10"></i>{{customerNote.date}}</div>
                            </div>
                        </div>



                        <div class="mr-sm-5 ml-sm-5  mt-4" v-html="customerNote.note" ></div>

                        <hr class="text-center mt-4 mb-4" style="width: 99%"/>
                        <div class="row pr-sm-2 pl-sm-2 pl-0 pr-0">
                            <div class="col-9 text-right">
                                <div  v-if="customerNote && customerNote.tagsList && customerNote.tagsList.length  " class="tag-list">
                                    <span v-for="(tag, index) in customerNote.tagsList" class="" :key="index">
                                        <b-badge href="#" variant="primary" class="font-size-12 text-uppercase font-weight-bold">{{ tag }}</b-badge>
                                    </span>
                                </div>
                            </div>
                            <div class="col-3 text-right">
                                <div class="float-sm-right mt-lg-0 mt-xl-0 mt-md-0">
                                    <i class="fas fa-edit font-size-16 font-weight-bold align-middle text-primary mr-2" @click="updateNote(customerNote)" style="cursor: pointer;"></i>
                                    <i class="fas fa-trash-alt font-size-16 font-weight-bold align-middle text-danger" @click="deleteNote(customerNote)" style="cursor: pointer;"></i>
                                </div>
                            </div>

                        </div>






                    </div>
                </div>
              </div>
            </div>
            <div v-if="!this.isGetNotesListStarting && this.pagemodel.maxPagesCount != this.pagemodel.currentPage && this.pagemodel.totalRows != 0" class="text-center mt-2 pt-4 font-size-16">
                <b-button variant="outline-primary mr-2" @click="loadMoreNotes()" class=" mt-2">  
                    {{ $t('customer.note.loadMore') }} 
                </b-button> 
            </div>
        </div>

        


    </div>
</template>

<style scoped>
.note-container {
    transition: all 0.3s ease;
}

.note-card{
    border-radius: 4px;
    border: 1px solid rgb(221, 221, 221);

}


.avatar {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background-color: #0c4822a6;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: normal;
    font-size: 1.2em; 
}

.tag-list {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
}



</style>
<style>

    .style-vselect .vs__search {
      line-height: 1;
      color: #333333;
      font-size: 1em;
    }

   

    .style-vselect-big .vs__search::placeholder,
    .style-vselect-big .vs__dropdown-toggle,
    .style-vselect-big .vs__search,
    .style-vselect-big .vs__dropdown-menu {
      line-height: 1.8;
      font-size: 1em;
      background: white;
    }

    .style-vselect-big .vs__clear,
    .style-vselect-big .vs__open-indicator {
      fill: #000; /*#d90100;*/
    }

</style>